import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// import VueDragscroll from 'vue-dragscroll'
import {   Carousel, CarouselItem, } from 'element-ui'

Vue.component(Carousel.name, Carousel);
Vue.component(CarouselItem.name, CarouselItem);
// Vue.use(VueDragscroll)
Vue.config.productionTip = false
document.title = '枢源科技';
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
